import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import { DialogContentText, DialogTitle } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { useTranslation } from 'react-i18next';
import Button from '../../modules/Button/Button';

export default function DialogComponent({
  modalBody,
  modalTitle,
  open,
  handleClose,
  handleDone,
  loading = false
}) {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{modalTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{modalBody}</DialogContentText>
      </DialogContent>
      <DialogActions style={{ textAlign: 'center' }}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          text={t('voucher_applications_modalNo')}
        />

        <Button
          onClick={() => {
            handleDone();
          }}
          color="secondary"
          variant="contained"
          loading={loading}
          text={t('voucher_applications_modalYes')}
        />
      </DialogActions>
    </Dialog>
  );
}
